/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';
import type { PriceListItemRequest } from '../types/PriceListItem';
import type { PriceListItemResponse } from '../types/PriceListItem';

export type PriceListItemsUpdateRequest = PriceListItemRequest;
export type PriceListItemsUpdateResponse = PriceListItemResponse;

export type PriceListItemsUpdateQuery = {
  /**
   * ```yaml
   * in: path
   * name: id
   * schema:
   *   type: integer
   * description: A unique integer value identifying this price list item.
   * required: true
   * ```
   */
  id?: number;
};

/**
 * PUT /dmx-server/price_list_items/{id}/
 *
 * ```yaml
 * operationId: price_list_items_update
 * tags:
 *   - price_list_items
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/PriceListItem'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/PriceListItem'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/PriceListItem'
 *   required: true
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/PriceListItem'
 *     description: ''
 * ```
 */
export const priceListItemsUpdateOperation = ({ id, ...rest }: PriceListItemsUpdateQuery) =>
  ({
    method: 'PUT',
    path: `/dmx-server/price_list_items/${id}/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'PUT';
    path: string & { _templateUrl: '/dmx-server/price_list_items/{id}/' };
  };

/**
 * PUT /dmx-server/price_list_items/{id}/
 *
 * ```yaml
 * operationId: price_list_items_update
 * tags:
 *   - price_list_items
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/PriceListItem'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/PriceListItem'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/PriceListItem'
 *   required: true
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/PriceListItem'
 *     description: ''
 * ```
 */
export const priceListItemsUpdate = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query: PriceListItemsUpdateQuery;
  request: PriceListItemRequest;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<PriceListItemResponse>> => {
  const operation = priceListItemsUpdateOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'PUT',
    request,
    onUploadProgress,
    cancelToken,
  );
};
